<template>
    <div>
        <div style="display: flex;flex-direction: column;">
            <div class="configRow">
                <div class="label">回调URL</div>
                <div class="set">
                    <el-input v-model="config.callBackUrl" placeholder="以POST方法提交到接口,请确保URL可以访问。"></el-input>
                </div>
            </div>
            <div class="configRow">
                <div class="label">自定义参数</div>
                <div class="set">
                    <el-input v-model="config.userParam" placeholder='填JSON串，例如{"name":"lucy"}'></el-input>
                </div>
            </div>
            <div class="configRow">
                <div class="label">接管提醒</div>
                <div class="set">
                    <el-radio-group v-model="config.callBackTakeRemind">
                        <el-radio :label="0">回调时不接管提醒</el-radio>
                        <el-radio :label="1">回调时接管提醒</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow">
                <div class="label">提醒时上传屏幕截图</div>
                <div class="set">
                    <el-radio-group v-model="config.uploadScreenShot">
                        <el-radio :label="0">不上传</el-radio>
                        <el-radio :label="1">上传</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow">
                <div class="label">鼠标点击(需插件)</div>
                <div class="set">
                    <el-radio-group v-model="config.useMouse">
                        <el-radio :label="0">不启用</el-radio>
                        <el-radio :label="1">启用单击</el-radio>
                        <el-radio :label="2">启用双击</el-radio>
                        <el-radio :label="3">动作编排</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="configRow" v-if="version=='5.02' && config.useMouse==3">
                <div class="label">动作编排</div>
                <div class="set">
                    <el-tooltip content="格式：(x,y,延时,按钮) 例如：(100,200,2,1)_(300,400,3,2)表示鼠标移动到(100,200),延时2秒,单击左键，再移动到(300,400),延时3秒,双击左键">
                        <el-input v-model="config.actionSequence" placeholder=""></el-input>
                    </el-tooltip>
                </div>
            </div>
            <div class="configRow" v-if="version=='5.02' && config.useMouse==1 || config.useMouse==2">
                <div class="label">点击延时</div>
                <div class="set"><el-input-number v-model="config.mouseDelay" :min="0" :max="10" 
                        label=""></el-input-number>秒</div>
            </div>

            <div class="configRow" v-if="version=='5.02' && config.useMouse==1 || config.useMouse==2">
                <div class="label">点击电脑</div>
                <div class="set">
                    <el-input v-model="config.clickIp" placeholder='默认本机127.0.0.1'></el-input>
                </div>
            </div>

            <div class="configRow" v-if="config.useMouse!=0">
                <div class="label">坐标类型</div>
                <div class="set">
                    <el-radio-group v-model="config.positionType" :disabled="config.useMouse==0">
                        <el-radio :label="0">相对坐标(找图、找色、找字的场景下以目标的中心点为原点)</el-radio>
                        <el-radio :label="1">绝对坐标(以电脑左上角0,0处为原点)</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div class="configRow" v-if="config.useMouse==1 || config.useMouse==2">
                <div class="label">坐标X偏移</div>
                <div class="set"><el-input-number v-model="config.offsetX" :min="-10240" :max="10240" :disabled="config.useMouse==0"
                        label=""></el-input-number>像素</div>
            </div>
            <div class="configRow" v-if="config.useMouse==1 || config.useMouse==2">
                <div class="label">坐标Y偏移</div>
                <div class="set"><el-input-number v-model="config.offsetY" :min="-10240" :max="10240" :disabled="config.useMouse==0"
                        label=""></el-input-number>像素</div>
            </div>
            <div class="configRow">
                <div class="label">备注说明</div>
                <div class="set">鼠标点击功能容易被误判为病毒，因此点击插件并不跟随软件一起安装,有需要的请另行在官方网站下载插件.如果是找字任务仅在“字符串包含”模式和“JS脚本”模式下生效，其它模式无法返回坐标</div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'AdvancedConfig',
    props: {
        task: Object,
        curTaskIndex: Number

    },
    data() {
        return {
            config: {
                callBackUrl: "",
                userParam:  "",
                callBackTakeRemind: 0,
                useMouse:  0,
                positionType: 0,
                offsetX: 0,
                offsetY: 0,
                uploadScreenShot: 0,
                version: ''
            },
        }
    },
    mounted() {
        this.config = this.task.advancedConfig
        this.version=localStorage.getItem("version")
    },
}
</script>

<style scoped>
.configRow {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid whitesmoke;
    margin-bottom: 20px;
}

.label {
    width: 25%;
}

.set {
    width: 75%;
}
</style>